module.exports = __webpack_public_path__ + "img/logo-footer.5f7a2c2b.svg";